enum ETreeTypeSortOrder {
  Project = 0,
  Folder = 1,
  Experiment = 2,
  Screen = 3,
  ProteinFormulation = 4,
  Seed = 5,
  FragmentScreen = 6,
}
export default ETreeTypeSortOrder;
